import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import MainPageComponent from "./main.page";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";
import { INSTANT_WIN_CREATE } from "modules/lucky-draw-v2/config/lucky-draw-v2.route";

export default function MainPageContainer() {
  const [activeIndex, setActiveIndex] = useState(0);
  const history = useHistory()
  const hasLuckyDrawV2AddEditAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_CREATE_INSTANT_WIN)
  );
  const hasInstantLuckyDrawViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Campaign.INSTANT_LUCKY_DRAW_READ));
  const lang = useSelector(state => state.constant.languages)

  useEffect(() => {
    if (!hasInstantLuckyDrawViewAccessRight) {
      history.push("/admin/dashboard")
    }
  }, [history, hasInstantLuckyDrawViewAccessRight])

  if (!hasInstantLuckyDrawViewAccessRight) return <LoadingComponent />;

  const tabLabels = [getLang(lang, "label.INSTANT_LUCKY_DRAW_LIST")];

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  const handleCreateInstantLuckyDraw = () => {
    history.push(INSTANT_WIN_CREATE);
  }

  return (
    <MainPageComponent
      hasLuckyDrawV2AddEditAccessRight={hasLuckyDrawV2AddEditAccessRight}
      handleChange={handleChange}
      activeIndex={activeIndex}
      tabLabels={tabLabels}
      handleCreateInstantLuckyDraw={handleCreateInstantLuckyDraw}
      lang={lang}
    />
  );
}
